/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useExpenseUrl } from 'domain/shared/expense';
import ExpenseBreadcrumbs from 'domain/finance/expenses/shared/ExpenseBreadcrumbs';

const SingleExpenseBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useExpenseUrl();
  const id = data?.getValueBySource('id');
  const expenseNumber = data?.getValueBySource('id');

  return (
    <ExpenseBreadcrumbs>
      <SingleBreadcrumbItem entity={expenseNumber || id} link={getSingleEntityUrl(id)} />
      {children}
    </ExpenseBreadcrumbs>
  );
};

export default SingleExpenseBreadcrumbs;
